module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [(_vm.loading) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary",
      "width": 7,
      "size": 70
    }
  })], 1)], 1) : _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('h1', {
    staticClass: "mt-3 text-xs-center"
  }, [_vm._v(_vm._s(_vm.location.locationName))]), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Street Address")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white lighten-3"
  }, [_vm._v(_vm._s(_vm.location.locationStreetAddress))])], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("City")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white lighten-3"
  }, [_vm._v(_vm._s(_vm.location.locationCity))])], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("State")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white lighten-3"
  }, [_vm._v(_vm._s(_vm.location.locationState))])], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Zipcode")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "white lighten-3"
  }, [_vm._v(_vm._s(_vm.location.locationZipcode))])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.userIsAuthenticated) ? [_c('v-spacer'), _vm._v(" "), _c('app-edit-location-dialog', {
    attrs: {
      "location": _vm.location
    }
  })] : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "red darken-3",
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.onDeleteLocation(_vm.location)
      }
    }
  }, [_c('v-icon', {
    staticClass: "text--lighten-1",
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("delete")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7672fef6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locations/Location.vue
// module id = 697
// module chunks = 1